/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi } from '@gasbuddy/react';
import { Modal, Header, Form, Button, Icon, Message, List } from 'semantic-ui-react';

function defaultState({ first, last }) {
  return { first, last };
}

export class EditNameModal extends React.Component {
  state = defaultState(this.props)

  callApi = () => {
    const { first, last } = this.state;
    const { accountId, onUpdate } = this.props;
    if (!first?.trim() || !last?.trim()) {
      this.setState({
        error: {
          log: [{ message: 'That does not appear to be a valid first and last name' }],
        },
      });
      return;
    }
    this.setState({ saving: true }, async () => {
      const { body, status, error } = await fetchApi({
        url: `/identity/user/${accountId}/set-name`,
        catchErrors: true,
        body: { first, last },
      });
      if (error || status !== 200) {
        this.setState({ error: body || error, saving: false });
      } else {
        onUpdate();
        this.setState({ opened: false, error: null, saving: false });
      }
    });
  }

  render() {
    const { buttonText } = this.props;
    const { opened, error, saving } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button size="mini" floated="right" onClick={() => this.setState({ opened: true })}>{buttonText}</Button>}
      >
        <Header icon="attention" content="Change Name" />
        <Modal.Content>
          {error
            && (
            <Message negative>
              <Message.Content>
                <List>
                  <List.Header>Cannot change name:</List.Header>
                  {(error.log || []).map(l => (
                    <List.Item>
                      {l.message}
                    </List.Item>
                  ))}
                </List>
              </Message.Content>
            </Message>
            )
          }
          <Form>
            <Form.Input
              fluid
              type="text"
              autoComplete="false"
              label="First Name"
              placeholder="John"
              onChange={(e, { value }) => this.setState({ first: value })}
            />
            <Form.Input
              fluid
              type="text"
              autoComplete="false"
              label="Last Name"
              placeholder="Smith"
              onChange={(e, { value }) => this.setState({ last: value })}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic color="grey" onClick={() => this.setState({ opened: false })}>
            <Icon name="minus" />
            {' '}
            Cancel
          </Button>
          <Button loading={saving} basic color="blue" onClick={this.callApi}>
            <Icon name="eye" />
            {' '}
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

EditNameModal.propTypes = {
  accountId: PT.number,
  onUpdate: PT.func.isRequired,
  buttonText: PT.string,
};

EditNameModal.defaultProps = {
  accountId: 0,
  buttonText: 'edit',
};
